import React from 'react';
import Icon from '../../../components/AppIcon';

const NavigationPanel = ({ 
  activeSection, 
  setActiveSection, 
  categories, 
  cities, 
  mappings
}) => {
  const navigationItems = [
    {
      id: 'categories',
      label: 'Categories & Subcategories',
      icon: 'FolderTree',
      description: 'Manage product categories',
      count: categories?.length || 0,
      badge: categories?.filter(c => c?.status === 'active')?.length
    },
    {
      id: 'cities',
      label: 'Cities & Areas',
      icon: 'MapPin',
      description: 'Geographic coverage management',
      count: cities?.length || 0,
      badge: cities?.filter(c => c?.status === 'active')?.length
    },
    {
      id: 'mapping',
      label: 'Category-City Mapping',
      icon: 'Network',
      description: 'Category availability by location',
      count: mappings?.length || 0,
      badge: mappings?.filter(m => m?.status === 'active')?.length
    }
  ];

  return (
    <div className="w-80 bg-card border-r border-border overflow-y-auto">
      <div className="p-4">
        <h2 className="text-lg font-semibold text-foreground mb-4">Navigation</h2>
        
        <nav className="space-y-2">
          {navigationItems?.map((item) => (
            <button
              key={item?.id}
              onClick={() => setActiveSection(item?.id)}
              className={`w-full flex items-center justify-between p-4 rounded-lg text-left transition-all duration-200 group ${
                activeSection === item?.id
                  ? 'bg-primary text-primary-foreground shadow-md'
                  : 'hover:bg-muted text-foreground hover:text-foreground'
              }`}
            >
              <div className="flex items-start space-x-3 flex-1 min-w-0">
                <Icon 
                  name={item?.icon} 
                  size={20} 
                  className={`flex-shrink-0 mt-0.5 ${
                    activeSection === item?.id 
                      ? 'text-primary-foreground' 
                      : 'text-muted-foreground group-hover:text-foreground'
                  }`}
                />
                <div className="flex-1 min-w-0">
                  <div className={`font-medium text-sm truncate ${
                    activeSection === item?.id 
                      ? 'text-primary-foreground' 
                      : 'text-foreground'
                  }`}>
                    {item?.label}
                  </div>
                  <div className={`text-xs truncate mt-1 ${
                    activeSection === item?.id 
                      ? 'text-primary-foreground/80' 
                      : 'text-muted-foreground'
                  }`}>
                    {item?.description}
                  </div>
                  {item?.count > 0 && (
                    <div className={`text-xs mt-1 ${
                      activeSection === item?.id 
                        ? 'text-primary-foreground/70' 
                        : 'text-muted-foreground'
                    }`}>
                      Total: {item?.count}
                    </div>
                  )}
                </div>
              </div>
              
              {item?.badge !== null && item?.badge > 0 && (
                <div className={`flex-shrink-0 ml-2 px-2 py-1 rounded-full text-xs font-medium ${
                  activeSection === item?.id
                    ? 'bg-primary-foreground text-primary'
                    : 'bg-primary text-primary-foreground'
                }`}>
                  {item?.badge}
                </div>
              )}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default NavigationPanel;